import { Fragment, useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
//--------------------------------------------------------------------------------------------
import TransitionWidthHeight from "src/components/common/TransitionWidthHeight";
import Resize from "src/components/common/resize";
import magnifierImg from "src/img/magnifier.png";
import UserInfo from "src/components/common/userInfo";
import Footer from "src/components/common/frame/footer";
import PaymentMethodForm from "src/components/paymentMethods/paymentMethodForm";
import { useMyStore } from "src/components/main/mainStore";
import {
    getTimeStamp, 
    boolAndReducer,
    myAxios, 
    scroll, 
    isDevMode,
    appTitle,
    MyFormData
} from "src/components/common/functions";

const title = "Payment Methods";
//--------------------------------------------------------------------------------------------
export default function PaymentMethods({ tabTitle }){
    const setShowLoader = useMyStore(state => state.setShowLoader);
    const user = useMyStore(state => state.user);
    const [updateDateTime, setUpdateDateTime] = useState(getTimeStamp());
    //--------------------------------------------------------------------------------------------
    const [paymentMethodsList, setPaymentMethodsList] = useState([]);
    const [showLoading, setShowLoading] = useState(false);
    const [usersList, setUsersList] = useState([]);
    const [typesList, setTypesList] = useState([]);
    const usersListMap = Object.fromEntries(usersList.map(user => [user.email, user]));
    const [currentPage, setCurrentPage] = useState(1);
    const [itemsPerPage, setItemsPerPage] = useState(10);
    const [filterWords, setFilterWords] = useState("");
    //--------------------------------------------------------------------------------------------
    const history = useHistory();
    //--------------------------------------------------------------------------------------------
    const pathname = history.location.pathname + (history.location.hash ?? "");
    const id = pathname.split("/")[2];
    const path = history.location.pathname;
    const path1 = decodeURIComponent(path.split("/")[1] ?? ""); // title
    const path2 = decodeURIComponent(path.split("/")[2] ?? ""); // id or "Add"
    
    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    
    const filterUserList = (paymentMethodsList || []).map(paymentMethod => 
        ({...paymentMethod, 
            creator: usersListMap[paymentMethod.createdBy]?.label
        })
    ).filter(paymentMethod => 
        (filterWords.toLowerCase().split(" ").map(f => JSON.stringify(
            Object.values(paymentMethod)
        ).toLowerCase().indexOf(f) > -1).reduce(boolAndReducer, true))
    );
    
    const currentUserList = filterUserList.slice(indexOfFirstItem, indexOfLastItem);
    const pageNumbers = Array.from({length: Math.ceil(filterUserList.length / itemsPerPage)}, (_, i) => (i + 1));
    //--------------------------------------------------------------------------------------------
    useEffect(() => {
        // if(isDevMode) console.log("useEffect");
        let isMounted = true;
        const controller = new AbortController();
        const getData = async() => {
            //-----------------------------------
            setShowLoading(true);
            const res = await myAxios("paymentMethods/readPaymentMethods.php", undefined, undefined, controller.signal);
            if(!isMounted) return;
            setShowLoading(false);
            if(!res) return;
            //-----------------------------------
            const responseData = res.data.data || res.data;
            setPaymentMethodsList(responseData.paymentMethods || []);
            setUsersList(responseData.users?.map(user => ({...user, value: user.email, label:user.userName})) || []);
            setTypesList(responseData.types || []);
            setShowLoading(false);
        }
        getData();
        return () => {
            isMounted = false;
            setShowLoader(false);
            controller.abort();
        }
    },[updateDateTime]);
    
    useEffect(() => {
        document.title = tabTitle;
        return () => {
            document.title = appTitle;
        };
    }, [tabTitle]);
    //--------------------------------------------------------------------------------------------
    const handleFormSuccess = (newPaymentMethod) => {
        setPaymentMethodsList([newPaymentMethod, ...paymentMethodsList]);
        setUpdateDateTime(getTimeStamp());
    }
    //--------------------------------------------------------------------------------------------
    const handleDelete = async (paymentMethodId) => {
        if(!window.confirm("Are you sure you want to delete this payment method?")) return;
        
        const formData = new MyFormData();
        formData.append("id", paymentMethodId);
        
        setShowLoader(true);
        const res = await myAxios("paymentMethods/deletePaymentMethod.php", formData);
        setShowLoader(false);
        
        if(!res) return;
        
        if(res.data.success) {
            setPaymentMethodsList(paymentMethodsList.filter(pm => pm.id !== paymentMethodId));
            if(id === paymentMethodId) {
                history.push(`/${path1}`);
            }
        }
    }
    //--------------------------------------------------------------------------------------------
    return(
        <Fragment>
        <div className = "cssTab">
            <div className = "cssHeader" style = {{background: user.userTheme}}>
                <span>
                    <Resize/>
                    {title}
                    <span data-toggle = "tooltip" title = {"Refreshed on " + updateDateTime} className = "btn btn-primary py-1 ml-4" onClick = {() => setUpdateDateTime(getTimeStamp())}>↻</span>
                </span>
                <span>
                    <input
                        className = "form-control w-auto"
                        type = "text"
                        value = {filterWords}
                        onChange = {e => {
                            setFilterWords(e.currentTarget.value.toLowerCase());
                            setCurrentPage(1);
                        }}
                    />
                    <img alt = "" src = {magnifierImg}/>
                </span>
                <span className = "pointer" onClick = {() => {history.push(`/${path1}/Add`);}}>Add</span>
                {id === "Add"?
                <PaymentMethodForm
                    keyword = "Add"
                    closeIt = {() => history.push(`/${path1}`)}
                    history = {history}
                    types = {typesList}
                    onSuccess = {handleFormSuccess}
                />
                :null}
            </div>
            <div className = "cssContent pb10">
                {showLoading?<div className = "cssLoading">Loading...</div>:
                !filterUserList.length?<div className = "cssLoading">Empty</div>:
                <div className = "table-responsive">
                    <table className = "table">
                        <thead>
                            <tr className = "noBorderTop">
                                <th>Type</th>
                                <th>Last 4</th>
                                <th>Time Created</th>
                                <th>User Created</th>
                                <th>Actions</th>
                            </tr>
                        </thead>
                        <tbody>
                            {currentUserList.map((paymentMethod, key) => 
                            <Fragment key = {key}>
                            <tr
                                id = {paymentMethod.id}
                            >
                                <td>{paymentMethod.type}</td>
                                <td>{paymentMethod.last4}</td>
                                <td>{paymentMethod.timeCreated}</td>
                                <td id = {paymentMethod.createdBy}>
                                    <UserInfo 
                                        name = {paymentMethod.creator}
                                        email = {paymentMethod.createdBy}
                                    />
                                </td>
                                <td>
                                    <button
                                        id = "deleteButton"
                                        className = "btn btn-danger btn-sm"
                                        onClick = {(e) => {
                                            e.stopPropagation();
                                            handleDelete(paymentMethod.id);
                                        }}
                                    >
                                        Delete
                                    </button>
                                </td>
                            </tr>
                            </Fragment>)}
                        </tbody>
                    </table>
                </div>}
                {!showLoading && filterUserList.length?
                <Footer
                    length = {filterUserList.length}
                    pageNumbers = {pageNumbers}
                    currentPage = {currentPage}
                    setCurrentPage = {setCurrentPage}
                    itemsPerPage = {itemsPerPage}
                    setItemsPerPage = {setItemsPerPage}
                />
                :null}
            </div>
        </div>
        </Fragment>
    )
}
